import * as ActionTypes from '../../constants/ActionTypes';

// Get store appointments (for store owners)
export const getStoreAppointments = (params = {}) => ({
    type: ActionTypes.GET_STORE_APPOINTMENTS_REQUEST,
    payload: params
});

export const getStoreAppointmentsSuccess = (data) => ({
    type: ActionTypes.GET_STORE_APPOINTMENTS_SUCCESS,
    payload: data
});

export const getStoreAppointmentsFailure = (error) => ({
    type: ActionTypes.GET_STORE_APPOINTMENTS_FAILURE,
    payload: error
});

// Confirm appointment (seller only)
export const confirmAppointment = (appointmentId) => ({
    type: ActionTypes.SELLER_CONFIRM_APPOINTMENT_REQUEST,
    payload: { appointmentId }
});

export const confirmAppointmentSuccess = (appointment) => ({
    type: ActionTypes.SELLER_CONFIRM_APPOINTMENT_SUCCESS,
    payload: appointment
});

export const confirmAppointmentFailure = (error) => ({
    type: ActionTypes.SELLER_CONFIRM_APPOINTMENT_FAILURE,
    payload: error
});

// Cancel appointment (seller perspective)
export const cancelAppointment = (appointmentId, reason = '') => ({
    type: ActionTypes.SELLER_CANCEL_APPOINTMENT_REQUEST,
    payload: { appointmentId, reason }
});

export const cancelAppointmentSuccess = (appointment) => ({
    type: ActionTypes.SELLER_CANCEL_APPOINTMENT_SUCCESS,
    payload: appointment
});

export const cancelAppointmentFailure = (error) => ({
    type: ActionTypes.SELLER_CANCEL_APPOINTMENT_FAILURE,
    payload: error
});

// Get appointment details (seller perspective)
export const getAppointmentDetails = (appointmentId, userTimezone = 'UTC') => ({
    type: ActionTypes.GET_APPOINTMENT_DETAILS_REQUEST,
    payload: { appointmentId, userTimezone }
});

export const getAppointmentDetailsSuccess = (appointment) => ({
    type: ActionTypes.GET_APPOINTMENT_DETAILS_SUCCESS,
    payload: appointment
});

export const getAppointmentDetailsFailure = (error) => ({
    type: ActionTypes.GET_APPOINTMENT_DETAILS_FAILURE,
    payload: error
});

// Clear appointment errors
export const clearAppointmentErrors = () => ({
    type: ActionTypes.CLEAR_APPOINTMENT_ERRORS
});

// Clear appointment success states
export const clearAppointmentSuccess = () => ({
    type: ActionTypes.CLEAR_APPOINTMENT_SUCCESS
});
